module.exports = new __parcel__URL__("hud_battle_royale_background.90b13de8.png").toString();